import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class Note extends Model<Schemas['notes'], Models> {}
